import { NgModule } from '@angular/core';

import { ConfigService } from '@digihaven/shared';

import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';
import { EnvironmentConfig } from '@common/entities/common/environment-config.entity';

import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

export function createApollo(
    httpLink: HttpLink,
    configService: ConfigService<EnvironmentConfig>
): ApolloClientOptions<any> {
    return {
        link: httpLink.create({ uri: `${configService.config.apiUrl}v1/odis/graphql` }),
        cache: new InMemoryCache()
    };
}

@NgModule({
    providers: [
        {
            provide: APOLLO_OPTIONS,
            useFactory: createApollo,
            deps: [HttpLink, ConfigService]
        }
    ]
})
export class GraphQLModule {}
